import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import ControlWorkProgram from "./controlWorkProgram";
import WorkProgramRequests from "../../Plan/Manager/workProgramRequests/WorkProgramRequests";
import "../../../styles/userManagement.css";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import LoaderScreen from '../../Common/loaderScreen' 
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import Questionnaire from "../ManageUsers/Questionnaire";
import ViewQuestionnaire from "../ManageUsers/viewQuestionnaire";
function MasterRepository() {
  const [currentTab, setCurrentTab] = useState(0);
  const [reset, setReset] = useState(false);
  const [controlWorkProgram, setControlWorkProgram] = useState([]);
  const [workProgramCategory, setWorkProgramCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const { sendRequest: categoryListAPI } = useHttp();
  const { sendRequest: deleteCtrlWorkProgramAPI } = useHttp();
  const { sendRequest: updateWorkProgramRequestAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const [allQuestinnaire, setAllQuestinnaire] = useState([]);
  const { sendRequest: fetchAllgetAllQuestinnaire } = useHttp();
  const [allOrganizations, setAllOrganizations] = useState([]);
  const { sendRequest: fetchAllOrganizations } = useHttp();

  const [workPrograms, setWorkPrograms] = useState();
  const { sendRequest: getWorkPrograms } = useHttp();
  useEffect(() => {
    getControlWorkProgram();
    getAllCtrlWPCategory();
    getWPRequest();
     getAllQuestinnaire();
    getAllOrganizations();
  }, []);

  const getWPRequest = async () => {
    getWorkPrograms(APIService.getWorkPrograms(), (data) => {
      setWorkPrograms(data.MSG[0])
    })
  };

  const getAllOrganizations = async () => {
    fetchAllOrganizations(APIService.fetchAllOrganizations(), (data) => {
      setAllOrganizations(data.MSG)
    })
  };
  
  const getAllQuestinnaire = async () => {
    fetchAllgetAllQuestinnaire(APIService.fetchAllgetAllQuestinnaire(), (data) => {
      setAllQuestinnaire(data.MSG)
    })
  };

  const controlWorkProgramResponse = (data) => {
    data.MSG.forEach(function (a) {
      a.valid_till = a.valid_till.substring(0, 10);
      a.valid_from = a.valid_from.substring(0, 10);
    });

    setControlWorkProgram(data.MSG);
    setLoading(false);
  };

  const getControlWorkProgram = async () => {
    setLoading(true);
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      controlWorkProgramResponse
    );
  };
  const getAllCtrlWPCategory = async () => {
    await categoryListAPI(APIService.getAllCtrlWPCategoryList(), (data) =>
      setWorkProgramCategory(data.MSG)
    );
  };
  const ChangeTab = () => {

    setCurrentTab(0);
    getControlWorkProgram();
    getAllCtrlWPCategory();
    getAllQuestinnaire();

  };
  const handleTabs = (v) => {
    setCurrentTab(v);
    setReset(!reset);
  };

  const updateCtrlWorkProgramResponse = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      getControlWorkProgram();
      setLoading(false);
    } else {
      setLoading(false);
      displayToastMessage("Something went wrong, Please try again!", "error");
    }
  };
  const updateCtrlWpDetailsById = async (data) => {
    setLoading(true);
    await updateWorkProgramRequestAPI(
      APIService.updateCtrlWorkProgram(data),
      updateCtrlWorkProgramResponse,
      (err) => {
        setLoading(false);
        displayToastMessage("Something went wrong, Please try again!", "error");
      }
    );
  };

  const deleteCtrlWorkProgramResponse = (result) => {
    if (result.CODE) {
      setLoading(false);
      displayToastMessage(result.MSG, "success");
      getControlWorkProgram();
    } else {
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const handleWpDelete = async (wpId, userId, email, setModalVisible) => {
    setLoading(true);
    try {
      let data = {
        wpID: wpId,
        userID: userId,
        email: email
      }
      await deleteCtrlWorkProgramAPI(
        APIService.deleteCtrlWorkProgramById(data), (result) => {
          if (result.CODE) {
            setLoading(false);
            displayToastMessage("Control Work Program has been deleted successfully", "success");
            getControlWorkProgram();
            setModalVisible(false);
          }
          else {
            setLoading(false);
            displayToastMessage("Something went wrong!", "error");
            setModalVisible(false);
          }
        }
      )
    } catch (error) {
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
      setModalVisible(false);
    }
  };


  const getQuestion=()=>{
    setCurrentTab(2);
 
    getAllQuestinnaire();
  }

  return (
    <div className="user-management-container">
      <Tabs
        activeIndex={currentTab}
        onTabChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="view_work" label="View Work Program">
            <WorkProgramRequests
              exitEdit={reset}
              workProgramData={controlWorkProgram}
              handleDelete={handleWpDelete}
            />
        </Tab>
        <Tab value="control_work" label="Create Work Program">
          <ControlWorkProgram
            sendBack={ChangeTab}
            reload={getControlWorkProgram}
            workProgramCategory={workProgramCategory}
            viewScreen={false}
          />
        </Tab>
        <Tab value="edit_user" label="Add Segmentation Question
">
          <Questionnaire reloadData={getQuestion}  />
        </Tab>
        <Tab value="organization" label="Configure Segmentation Questionnaire">
          <ViewQuestionnaire allOrganizations={allQuestinnaire} allOrganizationsData={allOrganizations}     sendBack={ChangeTab}/>
        </Tab>
      </Tabs>
    </div>
  );
}
export default MasterRepository;
